/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class SmartTilePropDateRange implements angular.IComponentOptions {
        templateUrl = "app/components/controls/smartCenterDesigner/propertyViews/smartTilePropDateRange.component.html";
            bindings: any = {
            prop: '=?',
            selectionChanged: '&?',
            model: '=?'
        };
        controller = class SmartTilePropDateRangeController {
            static $inject = [
                "meevo.components.common.DataService"
            ];

            public prop: Model.SmartTileParameter;
            public selectedItem: Model.EnumDto;
            public timePeriods: Model.EnumDto[] = [];
            public selectionChanged: Function;
            public model: Meevo.Model.SmartCenterSmartTile;

            constructor(protected dataService: Components.BaseClasses.IDataService) {}

            $onInit(): void {
                this.dataService.getEnumList(Model.EnumTypeEnum.TimePeriodEnum).then(timePeriods => {
                    this.timePeriods = timePeriods;
                    
                    // TODO: Find a cleaner implementation for custom date ranging
                    if (this.model) {
                        const excludedValues = SmartCenterDesignerPropertiesHelper.getExcludedDateRanges(this.model);
                        if (excludedValues) {
                            this.timePeriods = _(this.timePeriods).reject(tp => _(excludedValues).contains(tp.id));
                        }

                        const includedValues = SmartCenterDesignerPropertiesHelper.getIncludedDateRanges(this.model);
                        if (includedValues) {
                            this.timePeriods = _(this.timePeriods).filter(tp => _(includedValues).contains(tp.id));
                        }
                    }
                    
                    if (this.prop && this.prop.parameterValue) {
                        this.selectedItem = _.findWhere(this.timePeriods, { value: this.prop.parameterValue });
                    }
                });
            }

            onSelectionChanged(): void {
                this.prop.parameterValue = this.selectedItem.value;
                this.prop.parameterDisplayName = this.selectedItem.displayName;
                this.selectionChanged({ selection: this.selectedItem });
            }
        };
    }

    angular.module("meevo.components.controls")
        .component("stpDateRange", new SmartTilePropDateRange());
}
